import { render, staticRenderFns } from "./AnnouncementFilters.vue?vue&type=template&id=37dea4b6&"
import script from "./AnnouncementFilters.vue?vue&type=script&lang=js&"
export * from "./AnnouncementFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports